import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes.ts'

import { MyOrderList } from 'entities/common/my-ticket'

import { HeaderButton } from 'shared/ui/header-button'

import s from './styles.module.scss'

const MyOrdersArchive = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  console.log('test')

  const onClick = () => {
    navigate(RoutingPaths.myOrders.pathArchive())
  }

  return (
    <div className={clsx('container', s.container)}>
      <HeaderButton
        variant="grey"
        title={t('archive')}
        onClick={onClick}
      />

      <MyOrderList />
    </div>
  )
}

export default MyOrdersArchive
